import en from './en'
import fiFI from './fi-FI'
import svFI from './sv-FI'

export default {
	...en,
	...fiFI,
	...svFI,
}
